import { cx } from "@xinghai/ui";

/** The brand-palette illustrations in `public/illustrations` (640×640 WebP). */
export type IllustrationName =
  | "guide-quiet"
  | "guide-distance"
  | "guide-volume"
  | "guide-breath"
  | "guide-singing"
  | "guide-headphones"
  | "level-1"
  | "level-2"
  | "level-3"
  | "empty-inbox"
  | "empty-class"
  | "done-check";

export type IllustrationSize = "sm" | "md" | "lg" | "thumb";

const SIZES: Record<IllustrationSize, number> = {
  thumb: 48,
  sm: 96,
  md: 160,
  lg: 240,
};

export interface IllustrationProps {
  name: IllustrationName;
  /** @default "md" */
  size?: IllustrationSize;
  /** Caption rendered under the image. */
  caption?: string;
  className?: string;
}

/**
 * Decorative illustration. The images carry an ivory background, so they sit
 * on a light card that stays light in dark theme rather than being inverted.
 * Width and height are always explicit so nothing shifts while they load.
 */
export function Illustration({ name, size = "md", caption, className }: IllustrationProps) {
  const px = SIZES[size];
  return (
    <figure className={cx("xz-illus", `xz-illus--${size}`, className)}>
      <img
        className="xz-illus__img"
        src={`/illustrations/${name}.webp`}
        alt=""
        aria-hidden="true"
        width={px}
        height={px}
        loading="lazy"
        decoding="async"
        draggable={false}
      />
      {caption && <figcaption className="xz-illus__caption gz-caption">{caption}</figcaption>}
    </figure>
  );
}
